import { useEffect, useState } from "react";
import useFirestore from "shared/hooks/useFirestore";
import { report, student, ContentSettings } from "shared/types/Homework";
import { adjustSettingsForMissingContent, checkContentExistence } from "shared/utils/reportProgress";

const useHomeworkReportModal = (
    _selected_lesson: string,
    selected_student: student,
    selected_report: report
) => {
    const { readFirestoreOneDoc } = useFirestore();
    const [wordProgress, setWordProgress] = useState<any>();
    const [sentenceProgress, setSentenceProgress] = useState<any>();
    const [videoProgress, setVideoProgress] = useState<any>();
    const [reportSetting, setReportSetting] = useState<ContentSettings | null>(null);
    const [contentList, setContentList] = useState<string[]>([]);
    const [isOpenContentModal, setIsOpenContentModal] = useState<boolean>(false);

    useEffect(() => {
        if (selected_report?.release_id && selected_student?.uid) {
            getContentData();
            getContentSetting();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selected_report?.release_id, selected_student?.uid]);

    const getContentData = async () => {
        const [word_progress, sentence_progress, video_progress] = await Promise.all([
            getContentProgress("word"),
            getContentProgress("sentence"),
            getContentProgress("video"),
        ]);
        setWordProgress(word_progress);
        setSentenceProgress(sentence_progress);
        setVideoProgress(video_progress);
    };

    const getContentProgress = async (type: string) => {
        if (!selected_report || !selected_student) return undefined;
        const progressDoc = await readFirestoreOneDoc(
            `ReportProgress/${selected_student.uid}/${selected_report.release_id}`,
            type
        );
        return progressDoc.exists() ? progressDoc.data() : undefined;
    };

    const getContentSetting = async () => {
        let setting;
        if (selected_report.report_setting) {
            setting = selected_report.report_setting;
        } else {
            setting = await readFirestoreOneDoc(
                `${selected_report.path}/${selected_report.id}/Content`,
                "setting"
            ).then((res) => (res.exists() ? res.data() : null));
        }

        const contentExistence = await checkContentExistence(
            readFirestoreOneDoc,
            selected_report.path,
            selected_report.id
        );
        const adjustedSetting = adjustSettingsForMissingContent(setting, contentExistence);
        setReportSetting(adjustedSetting ?? null);
    };

    const onPartClickHandler = (content_list: string[]) => {
        setContentList(content_list);
        setIsOpenContentModal(true);
    };

    const onContentModalConfirmClickhandler = () => {
        setIsOpenContentModal(false);
    };

    return {
        wordProgress,
        sentenceProgress,
        videoProgress,
        reportSetting,
        onPartClickHandler,
        isOpenContentModal,
        contentList,
        onContentModalConfirmClickhandler,
    };
};

export default useHomeworkReportModal;
